import emptySplitApi from "../utils/rtk";
import { ApplicationById, CommonBody, PaymentResponse } from "../types/General";
import { END_POINTS } from "../constants/urls";
import { ApplicationList } from "../types/User";

type CommonResponseType = {
  status: number;
  message: string;
};

type GetApplicationsResponse = {
  length: number;
  start: number;
  response_object: ApplicationList[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const applicationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    applicationList: builder.mutation<
      CommonResponseType & { data: GetApplicationsResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.applicationListing,
        method: "POST",
        body,
      }),
    }),
    updateApplication: builder.mutation<
      CommonResponseType & { data: ApplicationList },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateApplication}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    editApplication: builder.mutation<
      CommonResponseType & { data: ApplicationList },
      { body: CommonBody; id: number | null }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.editApplication}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteApplication: builder.query<
      CommonResponseType & { data: ApplicationList },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteApplication}${id}/`,
        method: "DELETE",
      }),
    }),

    applicationDetails: builder.query<
      CommonResponseType & { data: ApplicationById | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.applicationDetail}${id}/`,
        method: "GET",
      }),
    }),
    applicationPayments: builder.query<
      CommonResponseType & { data: PaymentResponse[] },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.applicationPayments}${id}/`,
        method: "GET",
      }),
    }),
    applicationCounts: builder.query<
      CommonResponseType & {
        data: {
          BusinessVisa: number;
          StudyVisa: number;
          VisitVisa: number;
          WorkVisa: number;
        };
      },
   void
    >({
      query: () => ({
        url: `${END_POINTS.applicationCount}`,
        method: "GET",
      }),
    }),
    exportApplications: builder.mutation<
      CommonResponseType & { file_urls: string },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.exportApplications,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useApplicationListMutation,
  useLazyDeleteApplicationQuery,
  useLazyApplicationDetailsQuery,
  useUpdateApplicationMutation,
  useLazyApplicationPaymentsQuery,
  useLazyApplicationCountsQuery,
  useExportApplicationsMutation,
  useEditApplicationMutation,
} = applicationsApi;
